import React from 'react';

function DropDownItem(props) {
    const dropDownItems = props.elements;
    const fontStyle = props.fontStyle || 'font-light';
    const fontColor = props.fontColor || 'text-gray-500 dark:text-gray-400';
    const fontSize = props.fontSize || 'text-sm';
    const containerClass = props.containerClass || '';

    const handleTrigger = async (e) => {
        e.preventDefault();
        props.onTrigger(e);
    };

    return (
        <div className={containerClass}>
            <ul className={`py-1 w-full ${fontStyle} ${fontColor} ${fontSize}`}>
                {dropDownItems?.elements?.map((elem) => {
                    // Check for either the new hydrated "children" or the old "breadcrumbs"
                    const hasHierarchy = (elem.children && elem.children.length > 0) || 
                                         (elem.breadcrumbs && elem.breadcrumbs.length > 0);

                    return (
                        <li key={elem.id} className="w-full">
                            <button
                                value={[elem.id, elem.value]}
                                onClick={handleTrigger}
                                className={`
                                    w-full py-3 px-4 transition-all ease-in-out flex items-center justify-between
                                    hover:bg-gray-50 dark:hover:bg-gray-800 rounded-xl
                                    ${elem.logo ? 'justify-center' : ''}
                                `}
                            >
                                <div className="flex items-center">
                                    {elem.logo && (
                                        <svg 
                                            className="mr-3 w-6 h-6 text-gray-400" 
                                            fill="currentColor" 
                                            viewBox="0 0 20 20" 
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d={elem.logo}></path>
                                        </svg>
                                    )}
                                    <span className="text-left">{elem.name}</span>
                                </div>

                                {/* Hierarchy Indicator (Arrow) */}
                                {hasHierarchy && (
                                    <span className="text-2xl leading-none opacity-30 group-hover:opacity-100 transition-opacity ml-4">
                                        ›
                                    </span>
                                )}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default DropDownItem;